import { useFormContext } from '@calendly/form';
import { BodyText, HeadingText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { CloseButton } from '../../../share/components/close-button';
const containerIsPhoneCss = "c1eoul9t";
const containerCss = "c1drj1d9";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const contactContainerWithoutSubTitleCss = "c4namyl";
const contactContainerCss = "c1mzl1kr";
const ContactContainer = forwardRef((props, ref) => {
  const {
    withoutSubTitle,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(contactContainerCss, {
    [contactContainerWithoutSubTitleCss]: withoutSubTitle
  }, props.className)} />;
});
export const Header = ({
  title,
  subTitle,
  onClose
}) => {
  const {
    values
  } = useFormContext();
  return <Container>
      <ContactContainer withoutSubTitle={!subTitle}>
        <HeadingText level={1}>
          {title}
        </HeadingText>
        {subTitle && <BodyText color="muted" size="medium">
            {subTitle}
          </BodyText>}
      </ContactContainer>
      <CloseButton aria-label="close-button" onClick={() => onClose({
      subject: values.subject.plainText,
      body: values.body.html
    })} />
    </Container>;
};

require("./header.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./header.js");